var render = function render(){var _vm=this,_c=_vm._self._c;return _c('opinion-bar-vuex',{attrs:{"facility-id":_vm.facilityId}})
}
var staticRenderFns = []

export { render, staticRenderFns }